import { render, staticRenderFns } from "./DBMData.vue?vue&type=template&id=7353097e&lang=pug"
import script from "./DBMData.js?vue&type=script&lang=js&external"
export * from "./DBMData.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports